// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".oAuth-google-main{width:100%;height:50px;border:1px solid #3369E8;border-radius:3px;outline:none;background:#3369E8;cursor:pointer}.oAuth-google-text{float:left;width:180px;height:40px;margin-top:15px;font-size:16px;margin-top:12px;color:#fff !important}.oAuth-google-main:hover{border:1px solid white}\n", ""]);
// Exports
module.exports = exports;
